module.exports = __webpack_public_path__ + "static/media/status_hired.112568d2.svg";